import styled from 'styled-components';

const InputMessageStyled = styled.div`
  margin-top: 5px;
`;

export default InputMessageStyled;
